import React, { useState, useRef, useEffect } from "react";
import { MwButton, MwSpinner, NoDataFound } from "../ui";
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import {
  MdOutlineEdit,
  MdOutlineLocalShipping,
  MdOutlinePointOfSale,
  MdEdit,
  MdInventory2,
} from "react-icons/md";
import { CiViewList } from "react-icons/ci";
import { IoAddCircleOutline } from "react-icons/io5";
import { BsListUl } from "react-icons/bs";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCurrent } from "../../hooks";
import useFetch from "../../hooks/useFetch";
import useDelete from "../../hooks/useDelete";
import { Link, useParams, useNavigate } from "react-router-dom";
import DeleteConfirmationModal from "./RequisitionComponents/DeleteConfirmationModal";
import CardHeadeWithActions from "./../ui/CardHeadeWithActions";
import { useTranslation } from "react-i18next";
import { BiSearch } from "react-icons/bi";
import ActionsDropdown from "../common/ActionsDropdown";

const OsListRequisition = ({ idSelected, setIdSelected, setMode }) => {
  const [t, i18n] = useTranslation("global");
  const isRTL = i18n.dir() === "rtl";

  const { tenant } = useParams();
  const navigate = useNavigate();
  const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
  const apiUrl = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/requisitions/master/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
  const { data, loading, error, refreshHandler } = useFetch(apiUrl);
  const {
    deleteItem,
    loading: deleteLoading,
    error: deleteError,
  } = useDelete();
  console.log("data", data);
  const [menuVisible, setMenuVisible] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedUnitId, setSelectedUnitId] = useState(null);
  const [showAddOptions, setShowAddOptions] = useState(false);
  const [filterType, setFilterType] = useState("ALL");
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const addOptionsRef = useRef(null);
  const menuRef = useRef(null);

  const getTypeLabel = (type) => {
    switch (type) {
      case "PULL":
        return t("requisition.disbursement_requisition");
      case "PUSH":
        return t("requisition.receipt_requisition");
      case "TRANS":
        return t("requisition.transfer_requisition");
      default:
        return type;
    }
  };

  const handleManualAdd = () => {
    toast.info("تم النقر على الإضافة اليدوية", {
      style: {
        backgroundColor: "#e5e7eb",
        color: "#374151",
        padding: "1rem",
        borderRadius: "0.5rem",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      },
    });
    setShowAddOptions(false);
  };

  const handleManualDispense = () => {
    toast.info("تم النقر على الصرف اليدوي", {
      style: {
        backgroundColor: "#e5e7eb",
        color: "#374151",
        padding: "1rem",
        borderRadius: "0.5rem",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      },
    });
    setShowAddOptions(false);
  };

  const handleManualTransfer = () => {
    toast.info("تم النقر على التحويل اليدوي", {
      style: {
        backgroundColor: "#e5e7eb",
        color: "#374151",
        padding: "1rem",
        borderRadius: "0.5rem",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      },
    });
    setShowAddOptions(false);
  };

  const handleDelete = (id) => {
    setSelectedUnitId(id);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (selectedUnitId) {
      try {
        const deleteUrl = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/requisitions/master/${selectedUnitId}`;
        await deleteItem(deleteUrl);
        toast.success(t("deleted.delete_success"), {
          style: {
            backgroundColor: "#e5e7eb",
            color: "#374151",
            padding: "1rem",
            borderRadius: "0.5rem",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          },
        });
        refreshHandler();
      } catch (error) {
        toast.error(t("deleted.delete_error"), {
          style: {
            backgroundColor: "#e5e7eb",
            color: "#374151",
            padding: "1rem",
            borderRadius: "0.5rem",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          },
        });
      } finally {
        setDeleteModalOpen(false);
        setSelectedUnitId(null);
        setMenuVisible(null);
      }
    }
  };

  const toggleMenu = (id) => {
    setMenuVisible((prev) => (prev === id ? null : id));
  };

  const filterButtons = [
    { type: "ALL", label: t("requisition.all_products"), icon: BsListUl },
    {
      type: "PUSH",
      label: t("requisition.receipt_requisition"),
      icon: AiOutlinePlus,
    },
    {
      type: "PULL",
      label: t("requisition.disbursement_requisition"),
      icon: MdOutlinePointOfSale,
    },
    {
      type: "TRANS",
      label: t("requisition.transfer_requisition"),
      icon: MdOutlineLocalShipping,
    },
  ];
  const counts = {
    ALL: data?.data?.length || 0,
    PUSH: data?.data?.filter((item) => item.req_type === "PUSH").length || 0,
    PULL: data?.data?.filter((item) => item.req_type === "PULL").length || 0,
    TRANS: data?.data?.filter((item) => item.req_type === "TRANS").length || 0,
  };

  const filteredData = data?.data?.filter((item) => {
    const matchesType =
      filterType === "ALL" ? true : item.req_type === filterType;
    const matchesSearch =
      searchQuery.trim() === "" || item.req_no.toString().includes(searchQuery);
    return matchesType && matchesSearch;
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        addOptionsRef.current &&
        !addOptionsRef.current.contains(event.target)
      ) {
        setShowAddOptions(false);
      }
      const menuItem = event.target.closest("button, a");
      if (menuItem) return;
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuVisible(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (data?.data && searchQuery) {
      const filtered = data.data
        .filter((item) =>
          item.req_no
            .toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase()),
        )
        .map((item) => item.req_no);
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  }, [searchQuery, data]);

  if (loading) {
    return <MwSpinner />;
  }

  if (error) {
    return (
      <div className=" rounded-lg h-[calc(100vh-100px)] overflow-y-scroll custom-scrollbar">
        <CardHeadeWithActions
          icon={<MdInventory2 className="w-6 h-6" />}
          title={t("requisition.requisition_management")}
        >
          <div className="flex items-center gap-4">
            <div className="relative" ref={addOptionsRef}>
              <MwButton
                inGroup={true}
                type="saveBtn"
                onClick={() => setShowAddOptions(!showAddOptions)}
              >
                <IoAddCircleOutline className="w-6 h-6" />
                <span>{t("requisition.add_requisition")}</span>
              </MwButton>
              {showAddOptions && (
                <div className="absolute left-2 mt-2 w-40 bg-white shadow-lg rounded-md p-2 z-10 border border-gray-300 transform -translate-x-2">
                  <Link to={`/${tenant}/requisitionpush`}>
                    <button
                      onClick={handleManualAdd}
                      className="flex items-center gap-2 text-left px-4 py-2 text-sm text-[#251658] hover:bg-gray-100 w-full"
                    >
                      <AiOutlinePlus className="w-5 h-5" />
                      {t("requisition.receipt_requisition")}
                    </button>
                  </Link>
                  <Link to={`/${tenant}/requisitionpull`}>
                    <button
                      onClick={handleManualDispense}
                      className="flex items-center gap-2 text-left px-4 py-2 text-sm text-[#251658] hover:bg-gray-100 w-full"
                    >
                      <MdOutlinePointOfSale className="w-5 h-5" />
                      {t("requisition.disbursement_requisition")}
                    </button>
                  </Link>
                  <Link to={`/${tenant}/requisitiontrans`}>
                    <button
                      onClick={handleManualTransfer}
                      className="flex items-center gap-2 text-left px-4 py-2 text-sm text-[#251658] hover:bg-gray-100 w-full"
                    >
                      <MdOutlineLocalShipping className="w-5 h-5" />
                      {t("requisition.transfer_requisition")}
                    </button>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </CardHeadeWithActions>
        <div className="p-6 rounded-lg text-center text-red-500">
          <NoDataFound msg={t(`deleted.error_fetching_data`)} />
        </div>
      </div>
    );
  }

  if (data?.data?.length === 0) {
    return (
      <div className=" rounded-lg h-[calc(100vh-100px)] overflow-y-scroll custom-scrollbar">
        <CardHeadeWithActions
          title={
            <div className="flex items-center gap-2   ">
              <MdInventory2 className="w-6 h-6" />
              <span>{t("requisition.requisition_management")}</span>
            </div>
          }
        >
          <div className="flex items-center gap-4">
            <div className="relative" ref={addOptionsRef}>
              <MwButton
                inGroup={true}
                type="saveBtn"
                onClick={() => setShowAddOptions(!showAddOptions)}
              >
                <IoAddCircleOutline className="w-6 h-6" />
                <span>{t("requisition.add_requisition")}</span>
              </MwButton>
              {showAddOptions && (
                <div className="absolute left-2 mt-2 w-40 bg-white shadow-lg rounded-md p-2 z-10 border border-gray-300 transform -translate-x-2">
                  <Link to={`/${tenant}/requisitionpush`}>
                    <button
                      onClick={handleManualAdd}
                      className="flex items-center gap-2 text-left px-4 py-2 text-sm text-[#251658] gray-700 hover:bg-gray-100 w-full"
                    >
                      <AiOutlinePlus className="w-5 h-5" />
                      {t("requisition.receipt_requisition")}
                    </button>
                  </Link>
                  <Link to={`/${tenant}/requisitionpull`}>
                    <button
                      onClick={handleManualDispense}
                      className="flex items-center gap-2 text-left px-4 py-2 text-sm text-[#251658] hover:bg-gray-100 w-full"
                    >
                      <MdOutlinePointOfSale className="w-5 h-5" />
                      {t("requisition.disbursement_requisition")}
                    </button>
                  </Link>
                  <Link to={`/${tenant}/requisitiontrans`}>
                    <button
                      onClick={handleManualTransfer}
                      className="flex items-center gap-2 text-left px-4 py-2 text-sm text-[#251658] hover:bg-gray-100 w-full"
                    >
                      <MdOutlineLocalShipping className="w-5 h-5" />
                      {t("requisition.transfer_requisition")}
                    </button>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </CardHeadeWithActions>
        <NoDataFound msg={t("stocktaking.no_data_available")} />
      </div>
    );
  }

  return (
    <div className="rounded-lg w-[98%] mx-auto overflow-hidden h-full  ">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <CardHeadeWithActions
        icon={<MdInventory2 className="w-6 h-6" />}
        title={t("requisition.requisition_management")}
      >
        <div className="flex items-center gap-4">
          <div className="relative" ref={addOptionsRef}>
            <MwButton
              inGroup={true}
              type="saveBtn"
              onClick={() => setShowAddOptions(!showAddOptions)}
            >
              <IoAddCircleOutline className="w-6 h-6" />
              <span>{t("requisition.add_requisition")}</span>
            </MwButton>
            {showAddOptions && (
              <div className="absolute left-2 mt-2 w-40 bg-white shadow-lg rounded-md p-2 z-10 border border-gray-300 transform -translate-x-2">
                <Link to={`/${tenant}/requisitionpush`}>
                  <button
                    onClick={handleManualAdd}
                    className="flex items-center gap-2 text-left px-4 py-2 text-sm text-[#251658] hover:bg-gray-100 w-full"
                  >
                    <AiOutlinePlus className="w-5 h-5" />
                    {t("requisition.receipt_requisition")}
                  </button>
                </Link>
                <Link to={`/${tenant}/requisitionpull`}>
                  <button
                    onClick={handleManualDispense}
                    className="flex items-center gap-2 text-left px-4 py-2 text-sm text-[#251658] hover:bg-gray-100 w-full"
                  >
                    <MdOutlinePointOfSale className="w-5 h-5" />
                    {t("requisition.disbursement_requisition")}
                  </button>
                </Link>
                <Link to={`/${tenant}/requisitiontrans`}>
                  <button
                    onClick={handleManualTransfer}
                    className="flex items-center gap-2 text-left px-4 py-2 text-sm text-[#251658] hover:bg-gray-100 w-full"
                  >
                    <MdOutlineLocalShipping className="w-5 h-5" />
                    {t("requisition.transfer_requisition")}
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </CardHeadeWithActions>

      <div className=" w-[98%] mx-auto flex gap-48 justify-center my-5 border-b border-gray-200 pb-4">
        {filterButtons.map(({ type, label, icon: Icon }) => (
          <button
            key={type}
            onClick={() => setFilterType(type)}
            className={`flex flex-col items-center gap-2 px-4 py-2 rounded-md transition-all duration-300 ${
              filterType === type
                ? "bg-gray-200 text-[#251658]"
                : "bg-transparent text-[#251658] hover:bg-gray-200 focus:bg-gray-200"
            }`}
          >
            <Icon className="w-8 h-8" />
            <span className="text-sm">{label}</span>
            <span className="text-xs text-gray-500 bg-gray-100 rounded-full px-2 py-0.5">
              {counts[type]} {t("requisition.count")}
            </span>{" "}
          </button>
        ))}
      </div>
      <div className={`w-[98%] mx-auto flex ${isRTL ? "justify-end" : "justify-end"}`}>
        <div className="w-96 mt-4 text-gray-800 relative">
          <div className="relative">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && suggestions.length > 0) {
                  setSearchQuery(suggestions[0].toString());
                }
              }}
              placeholder={t("requisition.searchbynumberofrequisition")}
              className="w-full text-sm font-semibold text-[#251658] placeholder-gray-400 bg-white border border-gray-300 rounded-md py-2 px-4 pe-10 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-center shadow-sm"
              dir={isRTL ? "rtl" : "ltr"}
              autoComplete="off"
            />
            <div className="absolute top-1/2 transform -translate-y-1/2 right-3">
              <BiSearch className="h-5 w-5 text-gray-400" />
            </div>
          </div>

          {suggestions.length > 0 && (
            <ul className="absolute w-full bg-white border border-gray-300 rounded-md mt-1 max-h-48 overflow-y-auto z-50">
              {suggestions.map((suggestion, index) => (
                <li
                  key={index}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    setSearchQuery(suggestion.toString());
                    setSuggestions([]);
                  }}
                >
                  {suggestion}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {filteredData?.length === 0 ? (
        <div className="mt-2">
          <NoDataFound msg={t("requisition.no_requisition")} />
        </div>
      ) : (
        <div className=" rounded-lg h-[calc(100vh-100px)] overflow-y-scroll custom-scrollbar">
          <div className="h-[calc(100vh-300px)] overflow-hidden">
            <div className="sticky top-0 z-10">
              {/* Header */}
              <div className="grid grid-cols-12 gap-3 text-sm px-4 mt-2 bg-[#EBF9D9] font-bold text-[#251658] rounded-t-2xl justify-between items-center border-t py-4 hover:bg-indigo-50 hover:font-bold">
                <div className="text-center col-span-1">
                  {t("requisition.number")}
                </div>
                <div className="text-center col-span-2">
                  {t("requisition.type")}
                </div>
                <div className="text-center col-span-6">
                  {t("requisition.warehouse")}
                </div>
                <div className="text-center col-span-3">
                  {t("requisition.date_and_creator")}
                </div>
              </div>

              {/* Rows */}
              <div className="custom-scrollbar max-h-[calc(100vh-450px)] overflow-y-auto">
                {filteredData?.map((unit) => (
                  <div
                    key={unit.id}
                    className="grid grid-cols-12 gap-3 border-t px-2 py-2 cursor-pointer items-center"
                  >
                    {/* تغليف بيانات الطلب بالرابط */}
                    <Link
                      to={`/${tenant}/requisition-view/${unit.id}`}
                      className="contents"
                    >
                      <div className="text-[#251658] col-span-1 text-xs text-center">
                        {unit.req_no}
                      </div>
                      <div className="text-[#251658] col-span-2 text-xs text-center">
                        {getTypeLabel(unit.req_type)}
                      </div>
                      <div className="text-[#251658] col-span-6 text-xs text-center">
                        {unit.warehouse?.name_ar ||
                          t("requisition.there_is_no_warehouse")}
                      </div>
                    </Link>

                    {/* عمود المعلومات الإضافية والأكشنز خارج الرابط */}
                    <div className="flex justify-end col-span-3  gap-6  items-center text-[#251658] text-xs text-center relative">
                      <span>{unit.created_by}</span>
                      <span className="mx-2">|</span>
                      <span>
                        {new Date(unit.req_date).toLocaleDateString("en-EG", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                        })}
                      </span>
                      <ActionsDropdown
                        isRTL={isRTL}
                        onView={() => {
                          navigate(`/${tenant}/requisition-view/${unit.id}`);
                        }}
                        onEdit={() => {
                          navigate(`/${tenant}/requisition-update/${unit.id}`);
                        }}
                        onDelete={() => handleDelete(unit.id)}
                        itemId={unit.id}
                        viewText={t("requisition.view")}
                        editText={t("requisition.update")}
                        deleteText={t("requisition.delete")}
                        className="ml-4"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <DeleteConfirmationModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        loading={deleteLoading}
      />
    </div>
  );
};

export default OsListRequisition;
